export const TimeZoneService = Symbol('TimeZoneService');

/**
 * @description 时区服务
 */
export interface TimeZoneService {
    /**
     * 获取用户设置的时区
     * @description UTC偏移量（以分钟为单位，如：东八区返回480，西八区返回-480）
     * @returns UTC偏移量（分钟）
     */
    getUTCOffset(): number;
}

export const TimeZoneUpdater = Symbol('TimeZoneUpdater');

/**
 * @description 时区更新器
 */
export interface TimeZoneUpdater {
    /**
     * 更新时区
     * @param offset UTC偏移量（分钟）
     */
    updateTimeZone(offset: number): void;
}
